// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__MtltF","modalForm":"UpgradeEpcsModal_modalForm__ub7O4","modalFooter":"UpgradeEpcsModal_modalFooter__Isb-e"};